import React from 'react';
import * as classes from './Promo.module.scss'
import MediaQuery from 'react-responsive';
import { getFileName } from '../../helpers/FileCatching';
import { trackCustomEvent } from "../../helpers/tracking";

const contentImages = require.context('./images', true, /.*\.(gif|png|jpe?g|svg)$/i);

function Promo({content, GlobalData}) {
    
    function onPromoClick(title){
        let trackObject = {
          category: GlobalData.tracking.gaCategory,
          action: "Click",
          label: "Content " + title
        }
        trackCustomEvent(trackObject);
    }

    return (
        <div className={`${classes.Promo}`}>
            
            <div className={`${classes.Promo__maskBackground}`}>
                <img src={getFileName(contentImages,'Mask.png').default} alt={'Black curved background'}/>
            </div>      
            
            <div className={`${classes.Promo__wrapper}`}>
                <div className={classes.Promo__heroContainer}>
                    <div className={classes.Promo__heroSlot}>
                        <div className={classes.Promo__heroSlot__imageContainer}>
                            <a href={content.heroArticle.ctaURL} onClick={() => { onPromoClick(content.heroArticle.title) }}>
                                <MediaQuery maxWidth={classes.screenMdMax}>
                                    <img src={getFileName(contentImages,content.heroArticle.mobileImage).default} alt={content.heroArticle.imageAlt}/>
                                </MediaQuery>
                                <MediaQuery minWidth={classes.screenMd}>
                                    <img src={getFileName(contentImages,content.heroArticle.desktopImage).default} alt={content.heroArticle.imageAlt}/>
                                </MediaQuery>
                            </a>
                        </div>
                        <div className={classes.Promo__heroSlot__textWrap}>
                            <a href={content.heroArticle.ctaURL} onClick={() => { onPromoClick(content.heroArticle.title) }}><h3 className={`${classes.Promo__heroSlot__header} promoHeading`}>{content.heroArticle.heading}</h3></a>
                            <h2 className={` ${classes.Promo__heroSlot__title} promoTitle`}>{content.heroArticle.title}</h2>
                            <a href={content.heroArticle.ctaURL} onClick={() => { onPromoClick(content.heroArticle.title) }} className={`${classes.Promo__heroSlot__cta} button`}><p>{content.ctaText}</p></a>
                        </div>
                    </div>

                    
                    
                </div>
            </div>
        </div>
    );
}

export default Promo;